<template>
  <svg
    class="text-error"
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.2246 2.93877C13.4517 1.62197 11.5479 1.62197 10.775 2.93877L0.767943 19.9878C-0.014635 21.321 0.946791 23.0002 2.49278 23.0002H22.5068C24.0528 23.0002 25.0142 21.321 24.2316 19.9878L14.2246 2.93877ZM13.4998 8.00017H11.4998V16.0002H13.4998V8.00017ZM13.4998 18.0002H11.4998V20.0002H13.4998V18.0002Z"
      fill="currentColor"
    />
  </svg>
</template>
